export default __webpack_public_path__ + "static/studio-3-2-bac1fe9e34059ab593c68cb9384dd7f8.jpg";